import DefaultAddMonitoringDetails from "src/components/feature/AddMonitoringDetails";

const AddMonitoringDetails = () => {
  return <DefaultAddMonitoringDetails />;
};

export default AddMonitoringDetails;
